import React, { useEffect, useState, memo } from 'react';
import { connect } from 'react-redux';

import Popups from '../../components/Popup';
import { addEvent } from '../../actions/tradeShow';
import { usePopupContext } from '../../contexts/PopupContext';

const AddTradeShowEventPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const [event, setEvent] = useState({
    title: '',
    city: '',
    state: '',
    year: '',
    startDate: '',
    endDate: '',
    yearSuffix: '',
  });
  const [canSave, setCanSave] = useState(false);

  useEffect(() => {
    const emptyFields = [];

    Object.keys(event).forEach(field => {
      if (field !== 'title' && field !== 'yearSuffix' && event[field] === '') {
        emptyFields.push(field);
      }
    });

    setCanSave(!emptyFields.length);
  }, [event]);

  const handleClose = () => {
    closePopup();
  };

  const handleSave = () => {
    if (canSave) {
      props.addEvent(event);
      handleClose();
    }
  };

  const handleChange = (value, name) => {
    setEvent({
      ...event,
      [name]: value,
    });
  };

  return (
    <Popups.AddTradeShowEventPopup
      canSave={canSave}
      event={event}
      onChange={handleChange}
      onClose={handleClose}
      onSave={handleSave}
    />
  );
};

const mapStateToProps = () => ({});

export { AddTradeShowEventPopupContainer };
export default connect(mapStateToProps, { addEvent })(memo(AddTradeShowEventPopupContainer));
